import { themeDark } from '@themes/dark/theme.dark';
import { themeLight } from '@themes/light/theme.light';
import { ThemeConfig, ThemeIds } from '@themes/theme.types';

export const themes: ThemeConfig[] = [
  { value: ThemeIds.Light, title: 'Light theme', theme: themeLight },
  { value: ThemeIds.Dark, title: 'Dark theme', theme: themeDark },
];
